import {
  IonBadge,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonMenuButton,
  IonRefresher,
  IonRefresherContent,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {actions, RootState} from '../store';
import "./DressageProtocolListPage.css"
import DressageProtocolListItem from "../domain/DressageProtocolListItem";
import {PluginListenerHandle, Plugins} from "@capacitor/core";
import {DressageProtocolCategory, getCategoryLabel} from "../domain/DressageProtocolCategory";

type DressageProtocolListPageProps =
  RouteComponentProps<{ contestId: string, tab: string }>
  & typeof mapDispatchToProps
  & {
  dressageProtocols: DressageProtocolListItem[];
  lastUpdatedTimeStamp: Date
};
type State = {
  isRefreshing: boolean,
  showLoading: boolean,
  segment: DressageProtocolFilter
}

type DressageProtocolFilter = "all" | "horse" | "pony";

const groupBy = (array: Array<any>, key: any) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

class DressageProtocolListPage extends React.Component<DressageProtocolListPageProps, State> {
  private ionRefresherRef: React.RefObject<HTMLIonRefresherElement>;
  private backButtonHandle ?: PluginListenerHandle;

  constructor(props: DressageProtocolListPageProps) {
    super(props);
    this.state = {
      isRefreshing: false,
      showLoading: false,
      segment: 'all'
    };
    props.updateDressageProtocolList();
    this.ionRefresherRef = React.createRef<HTMLIonRefresherElement>();
  }

  componentDidMount(): void {
    this.backButtonHandle = Plugins.App.addListener('backButton', () => this.props.history.push("/"));
  }

  componentWillUnmount(): void {
    this.backButtonHandle!.remove()
  }

  render() {
    let content;

    if (!this.props.dressageProtocols || this.props.dressageProtocols.length === 0) {
      content = <IonText>Deze zijn momenteel nog niet beschikbaar.</IonText>;
    } else {
      content = this.renderProtocols(this.props.dressageProtocols);
    }
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>LRV digitaal - Dressuurproeven</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonRefresher ref={this.ionRefresherRef} onIonRefresh={this.doRefresh}>
            <IonRefresherContent/>
          </IonRefresher>
          <div className={"dressage-test-list-content"}>
            <IonSegment onIonChange={(e: CustomEvent) => this.updateSegment(e)}>
              <IonSegmentButton value="all" checked={this.state.segment === 'all'}>
                Alle
              </IonSegmentButton>
              <IonSegmentButton value="horse" checked={this.state.segment === 'horse'}>
                Paarden
              </IonSegmentButton>
              <IonSegmentButton value="pony" checked={this.state.segment === 'pony'}>
                Pony's
              </IonSegmentButton>
            </IonSegment>

            {content}
          </div>
        </IonContent>
      </>
    );
  }

  renderProtocols(dressageProtocols: DressageProtocolListItem[]) {
    const filtered = this.filterProtocol(dressageProtocols, this.state.segment);
    const grouped = groupBy(filtered, 'category');
    return Object.keys(grouped).map(key => {
      const protocols: Array<DressageProtocolListItem> = grouped[key];
      return (<IonItemGroup key={key}>
        <IonItemDivider>
          <IonLabel>{getCategoryLabel(key as DressageProtocolCategory)}</IonLabel>
        </IonItemDivider>
        {protocols.map((p: DressageProtocolListItem, index: number) => this.renderProtocolListItem(p, index))}
      </IonItemGroup>);
    });
  }

  renderProtocolListItem(item: DressageProtocolListItem, index: number) {
    return (
      <IonItem key={item.id}
               button
               onClick={() => this.props.history.push(`/dressage-protocols/${item.id}`)}>
        <IonLabel class="label" text-wrap>
          <h2 className="label-content">{item.series}</h2>
          <p className="label-content"><IonBadge>{item.horse ? 'Paarden' : 'Pony\'s'}</IonBadge> {item.protocolNumber}</p>
        </IonLabel>
      </IonItem>
    );
  }

  filterProtocol(dressageProtocols: DressageProtocolListItem[], filter: DressageProtocolFilter) {
    if (filter == "all") {
      return dressageProtocols;
    }
    const horse: boolean = filter == "horse";
    return dressageProtocols.filter(protocol => horse ? protocol.horse : !protocol.horse);
  }

  doRefresh = () => {
    setTimeout(() => {
      this.setState(prevState => ({
        ...prevState,
        isRefreshing: true
      }));
      if (this.ionRefresherRef.current) {
        this.ionRefresherRef.current.complete();
      }
      this.props.updateDressageProtocolList();
    }, 500);
  };

  private updateSegment(e: CustomEvent) {
    this.setState(prevState => ({
      ...prevState,
      segment: e.detail.value
    }));
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    lastUpdatedTimeStamp: state.dressageProtocols.lastUpdatedTimeStamp,
    dressageProtocols: state.dressageProtocols.dressageProtocols
  }
};

const mapDispatchToProps = {
  updateDressageProtocolList: () => actions.dressageProtocolList.updateDressageProtocols()
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DressageProtocolListPage);
